module.exports = __webpack_public_path__ + "img/d4.d577472c.png";